import React, { createContext, useContext } from 'react';
import { noop } from 'lodash';
import { useContentEntriesInternal } from './UseContentEntriesInternal';

type ContentEntriesContext = ReturnType<typeof useContentEntriesInternal>;

const initialContext: ContentEntriesContext = {
  items: [],
  setItems: noop,
  activePage: undefined,
  setActivePage: noop,
};

export const ContentEntriesContext = createContext<ContentEntriesContext>(initialContext);

export const useContentEntriesContext = () => useContext(ContentEntriesContext);

export const ContentEntriesProvider: React.FC<{ initialItems?: ContentEntriesContext['items'] }> = ({
  children,
  initialItems,
}) => {
  return (
    <ContentEntriesContext.Provider value={useContentEntriesInternal(initialItems)}>
      {children}
    </ContentEntriesContext.Provider>
  );
};

export const ContentEntriesConsumer = ContentEntriesContext.Consumer;
